import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const SCROLL_THRESHOLD = 300;

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.pageYOffset ?? document.documentElement.scrollTop;
      setVisible(scrollY > SCROLL_THRESHOLD);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  const button = (
    <button
      type="button"
      id="scroll-to-top-btn"
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className="scroll-to-top-fab"
      style={{
        position: 'fixed',
        bottom: '72px',
        right: '16px',
        width: '48px',
        height: '48px',
        borderRadius: '50%',
        backgroundColor: '#1D2A3B',
        border: '2px solid #D5B577',
        cursor: 'pointer',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#D5B577',
        zIndex: 99998,
        transition: 'opacity 0.2s ease, transform 0.2s ease, background-color 0.2s ease, color 0.2s ease',
        padding: 0,
      }}
      onMouseEnter={(e) => {
        const el = e.currentTarget;
        el.style.backgroundColor = '#D5B577';
        el.style.color = '#1D2A3B';
        el.style.transform = 'translateY(-6px) scale(1.05)';
        el.style.animationPlayState = 'paused';
      }}
      onMouseLeave={(e) => {
        const el = e.currentTarget;
        el.style.backgroundColor = '#1D2A3B';
        el.style.color = '#D5B577';
        el.style.transform = '';
        el.style.animationPlayState = 'running';
      }}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
      </svg>
    </button>
  );

  return createPortal(button, document.body);
};

export default ScrollToTopButton;
